import { g as gsapWithCSS } from "@theme/theme";
class ProductOverviewComponent extends window.HTMLElement {
  constructor() {
    super();
    this.DOM = {
      filterGroups: this.querySelectorAll(".js-collection-filter-group"),
      filterBtns: this.querySelectorAll(".js-filter-btn"),
      filterBtnAll: this.querySelector(".js-filter-btn-all"),
      productCards: this.querySelectorAll(".js-product-card"),
      grid: this.querySelector(".js-product-overview-grid"),
      toggleFilters: this.querySelector(".js-toggle-filters"),
      toggleFiltersText: this.querySelector(".js-toggle-filters span"),
      filtersBody: this.querySelector(".js-filters-body"),
      termTextItems: this.querySelectorAll(".js-term-text")
    };
    const url = new URL(window.location.href);
    this.state = {
      filters: {
        type: url.searchParams.get("type") || null,
        grape: url.searchParams.get("grape") || null
      }
    };
  }
  connectedCallback() {
    this.setActiveButtons();
    this.bindEvents();
    this.filterProducts(true);
    this.validateFilters();
    this.updateToggleFiltersText();
  }
  setActiveButtons() {
    this.updateAllButtonState();
    this.DOM.filterBtns.forEach((btn) => {
      const group = btn.closest(".js-collection-filter-group");
      const groupName = group.getAttribute("data-group");
      const filterValue = this.state.filters[groupName];
      if (filterValue && btn.textContent.trim().toLowerCase() === filterValue.toLowerCase()) {
        btn.classList.add("is-active");
      }
    });
  }
  bindEvents() {
    this.DOM.filterBtnAll.addEventListener("click", this.handleAllButtonClick.bind(this));
    this.DOM.filterBtns.forEach((btn) => {
      btn.addEventListener("click", this.handleFilterClick.bind(this));
    });
    this.DOM.toggleFilters.addEventListener("click", this.handleToggleFilters.bind(this));
  }
  updateAllButtonState() {
    const hasActiveFilters = Object.values(this.state.filters).some((v) => v !== null);
    this.DOM.filterBtnAll.classList.toggle("is-active", !hasActiveFilters);
  }
  handleAllButtonClick() {
    if (this.DOM.filterBtnAll.classList.contains("is-active")) {
      return;
    }
    Object.keys(this.state.filters).forEach((key) => {
      this.state.filters[key] = null;
    });
    this.DOM.filterBtns.forEach((btn) => {
      btn.classList.remove("is-active");
    });
    this.updateAllButtonState();
    this.updateUrl();
    this.filterProducts();
    this.validateFilters();
    this.updateToggleFiltersText();
    if (this.DOM.toggleFilters.classList.contains("is-active")) {
      this.handleToggleFilters();
    }
  }
  handleFilterClick(event) {
    const btn = event.currentTarget;
    const group = btn.closest(".js-collection-filter-group");
    const groupName = group.getAttribute("data-group");
    const isAlreadyActive = btn.classList.contains("is-active");
    group.querySelectorAll(".js-filter-btn").forEach((groupBtn) => {
      groupBtn.classList.remove("is-active");
    });
    if (isAlreadyActive) {
      this.state.filters[groupName] = null;
    } else {
      btn.classList.add("is-active");
      this.state.filters[groupName] = btn.textContent.trim();
    }
    this.updateAllButtonState();
    this.updateUrl();
    this.filterProducts();
    this.validateFilters();
    this.updateToggleFiltersText();
    if (this.DOM.toggleFilters.classList.contains("is-active")) {
      this.handleToggleFilters();
    }
  }
  updateUrl() {
    const url = new URL(window.location.href);
    Object.entries(this.state.filters).forEach(([key, value]) => {
      if (value) {
        url.searchParams.set(key, value);
      } else {
        url.searchParams.delete(key);
      }
    });
    window.history.replaceState({}, "", url);
  }
  filterProducts(init = false) {
    const duration = init ? 0 : 0.5;
    const hasActiveFilters = Object.values(this.state.filters).some((v) => v !== null);
    gsapWithCSS.to(this.DOM.grid, {
      y: 20,
      autoAlpha: 0,
      duration,
      onComplete: () => {
        let visibleOrder = 1;
        this.classList.toggle("has-filters", hasActiveFilters);
        this.updateTermText();
        this.DOM.productCards.forEach((card) => {
          const cardType = card.getAttribute("data-type").toLowerCase() || "";
          const cardGrape = card.getAttribute("data-grape").toLowerCase() || "";
          const matchesType = !this.state.filters.type || cardType.split(",").some((t) => t.trim() === this.state.filters.type.toLowerCase());
          const matchesGrape = !this.state.filters.grape || cardGrape.split(",").some((g) => g.trim() === this.state.filters.grape.toLowerCase());
          if (matchesType && matchesGrape) {
            card.style.display = "";
            if (hasActiveFilters) {
              if (visibleOrder === 3) visibleOrder++;
              card.style.order = visibleOrder++;
            } else {
              card.style.order = "";
            }
          } else {
            card.style.display = "none";
            card.style.order = "";
          }
        });
        gsapWithCSS.to(this.DOM.grid, { y: 0, autoAlpha: 1, duration });
      }
    });
  }
  validateFilters() {
    this.DOM.filterGroups.forEach((group) => {
      const groupName = group.getAttribute("data-group");
      const buttons = group.querySelectorAll(".js-filter-btn");
      buttons.forEach((btn) => {
        const filterValue = btn.textContent.trim();
        const count = this.getFilteredCount(groupName, filterValue);
        btn.classList.toggle("is-disabled", count === 0);
      });
    });
  }
  getFilteredCount(targetGroup, targetValue) {
    let count = 0;
    const testFilters = { ...this.state.filters };
    testFilters[targetGroup] = targetValue;
    this.DOM.productCards.forEach((card) => {
      const matches = Object.entries(testFilters).every(([filterKey, filterValue]) => {
        if (!filterValue) return true;
        const cardAttr = card.getAttribute(`data-${filterKey}`) || "";
        const cardValues = cardAttr.split(",").map((v) => v.trim().toLowerCase());
        return cardValues.includes(filterValue.toLowerCase());
      });
      if (matches) count++;
    });
    return count;
  }
  updateTermText() {
    const { type, grape } = this.state.filters;
    const activeTerm = grape ? grape.toLowerCase() : type ? type.toLowerCase() : null;
    this.DOM.termTextItems.forEach((item) => {
      const term = item.getAttribute("data-term").toLowerCase();
      item.style.display = activeTerm && activeTerm === term ? "block" : "none";
    });
  }
  handleToggleFilters() {
    this.DOM.toggleFilters.classList.toggle("is-active");
    gsapWithCSS.to(this.DOM.filtersBody, {
      height: this.DOM.toggleFilters.classList.contains("is-active") ? "auto" : 0,
      duration: 0.5,
      ease: "easeInOutStrong"
    });
  }
  updateToggleFiltersText() {
    const activeFilters = Object.values(this.state.filters).filter((v) => v !== null);
    if (activeFilters.length === 0) {
      this.DOM.toggleFiltersText.textContent = this.DOM.filterBtnAll.textContent;
    } else if (activeFilters.length === 1) {
      this.DOM.toggleFiltersText.textContent = activeFilters[0];
    } else {
      this.DOM.toggleFiltersText.textContent = activeFilters.join(" - ");
    }
  }
}
window.customElements.define("c-product-overview", ProductOverviewComponent);
